import { Component } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { HttpClient } from "@angular/common/http"
import { take } from 'rxjs/operators'
import { publicHelpers } from '../../helpers/public-helpers'
import { BrandingData } from 'globals/store/publish.data'
import { BrandingWrapperComponent } from 'src/app/components/branding/branding-wrapper.component'
import { SharedTimelineComponent } from 'src/app/components/wrappers/shared-timeline-wrapper.component'
import { ExpandingWrapperComponent } from 'src/app/components/wrappers/expanding-wrapper.component'
import { TimelineItemComponent } from 'src/app/components/timeline/timeline-item.component'
import { CommonModule } from '@angular/common'
import { IconComponent } from 'src/app/components/icon/icon.component'
import { environment } from '../../../environments/environment'
import { FacilitatorShareData } from 'globals/share/share.facilitator.functions'


@Component({
    selector: 'share-facilitator-notes',
    providers: [],
    template: `
<branding-wrapper [brandingData]="brandingData" 
  [style.--sitebackground]="brandingData?.template?.sitebackground || '#ffffff'"
  [hideHeader]="false"
  [hideSocial]="false"
  [hideFooter]="false"
>
  <shared-timeline-wrapper 
    [eventTitle]="data?.eventTitle"
    [title]="data?.programTitle"
    [madeWithJoi]="true"
    [isFacilitator]="true"
    [loading]="loading"
    [venue]="data?.venue"
    [roomName]="data?.location"
    [labelIds]="data?.labelIds"
    [labelMap]="data?.labelMap"
    [unavailable]="!data && !loading"
  >
    <div class="main-notes-holder" *ngIf="!!data && !loading"> 
      <div class="menu">
        <div style="flex:1;"></div>
        <icon [icon]="'grow'" (click)="$event.stopPropagation(); expandAll()"></icon>
        <icon [icon]="'shrink'" (click)="$event.stopPropagation(); collapseAll()"></icon>
      </div>
      <expanding-wrapper
        class="notes"
        [ngClass]="{ expanded: !collapsedStates['program'] }"
        [initOpen]="true"
        [borderGreyOnCollapse]="false"
        [expandedState]="collapsedStates['program'] ? 'collapse' : 'expand'"
        [manualToggle]="true"
        (onToggle)="toggleExpanded('program')"
      >
        <div class="header-left"><h4>Facilitator Notes</h4><icon [icon]="'DESCRIPTION18'"></icon></div>
        <div class="notes-body" *ngIf="!!data.facilitatorNotes" [innerHTML]="helpers.strWithBreak(data.facilitatorNotes)"></div>
        <div class="missing notes-body" *ngIf="!data.facilitatorNotes">No facilitator notes</div>
      </expanding-wrapper>

      <ng-container *ngFor="let day of data.timeline">
        <h3 class="day-title">{{ day.date < 1000 ? 'Day ' + day.date : day.date | date:"EEEE d LLLL y" }}</h3>
        <ng-container *ngFor="let session of day.sessions; index as i; first as first; last as last">
          <timeline-item 
            *ngIf="{ priorSession: day.sessions[i-1], latterSession: day.sessions[i+1] } as vars"
            [start]="!!first ? session.start : vars.priorSession.start === session.start && vars.priorSession.end === session.end ? null : session.start" 
            [hideDot]="vars.latterSession && vars.latterSession.start < session.end && vars.latterSession.end >= session.end"
            [narrowPerformersHeading]="true"
            [condensedPerformers]="false"
            [collapsible]="!session.break"
            [isBreak]="session.break"
            [end]="session.end"
            [duration]="session.duration"
            [printDate]="day.dateString"
            [forcedCollapseState]="collapsedStates[session.sessionId] ? 'collapse' : 'expand'"
            [manualCollapse]="true"
            (onToggleCollapse)="toggleExpanded(session.sessionId)"
            [first]="first" 
            [last]="last" 
            [link]="false"
            [timeAbove]="true"
            [title]="session.title"
            [description]="session.description" 
            [performers]="data.performers" 
            [performerIds]="session.performerIds"
            [performerRoles]="data.performerRoles"
            [performerRoleIds]="session.performerRoleIds"
            [sponsors]="data.sponsors"
            [sponsorIds]="session.sponsorIds"
            [programLine]="session.programText"
          >
          <expanding-wrapper
            class="info-bottom notes"
            [initOpen]="true"
            [borderGreyOnCollapse]="false"
            [ngClass]="{ expanded: !collapsedStates[session.sessionId + 'notes'] }"
            [expandedState]="collapsedStates[session.sessionId + 'notes'] ? 'collapse' : 'expand'"
            [manualToggle]="true"
            (onToggle)="toggleExpanded(session.sessionId + 'notes')"
          >
            <div class="header-left"><h4>Facilitator Notes</h4><icon [icon]="'DESCRIPTION18'"></icon></div>
            <div class="notes-body" *ngIf="!!session.facilitatorNotes" [innerHTML]="helpers.strWithBreak(session.facilitatorNotes)"></div>
            <div class="missing notes-body" *ngIf="!session.facilitatorNotes">No facilitator notes</div>
          </expanding-wrapper>
          </timeline-item>
        </ng-container>
      </ng-container>
    </div>
  </shared-timeline-wrapper>
</branding-wrapper>
    `,
    styleUrls: ['share.notes.scss'],
    standalone: true,
    imports: [BrandingWrapperComponent, SharedTimelineComponent, IconComponent, ExpandingWrapperComponent, TimelineItemComponent, CommonModule]
})
export class ShareNotesComponent {

    readonly api = `${environment.functionsURL}api/v1`; // NOTE this is pointing to api/v1 not api/app

    publishCode:string;
    collapsedStates = {}
    
    baseShareUrl = environment.joi.shareBase
    helpers = publicHelpers
    error: string

    loading = true;
    unavailableMessage = "These facilitator notes are currently not available.\n\nPlease contact the event organiser."
    data: FacilitatorShareData
    brandingData: BrandingData

    constructor(private route:ActivatedRoute, private http:HttpClient ) {
      this.route.params.subscribe(params=>{
        if(!params || !params.hasOwnProperty('publishCode')) {
          this.loading = false;
          document.title = "Facilitator Notes Unavailable";
        } else {
          this.publishCode = params.publishCode
          this.downloadSharedNotes(this.publishCode)
        }
        document.title = "loading";
      })
    }

    expandAll() {
      this.collapsedStates = {}
    }
    
    collapseAll() {
      this.collapsedStates['program'] = true
      this.data.timeline.forEach(d => d.sessions.forEach(s => {
        this.collapsedStates[s.sessionId] = true 
        this.collapsedStates[`${s.sessionId}notes`] = true 
      }))
    }

    toggleExpanded(id: string) {
      this.collapsedStates[id] = !this.collapsedStates[id]
    }


    async downloadSharedNotes(publishCode) {
      console.log(publishCode)
      const url = `${this.api}/facilitator-notes/${publishCode}`
      this.http.get(url).pipe(take(1)).subscribe((data: FacilitatorShareData) => {
        this.data = data
        this.brandingData = data.brandingData
        console.log(data)
        document.title = data.eventTitle || data.programTitle || 'Untitled Facilitator notes from Joi'
        this.loading = false;
      }, (error) => {
        console.log(error)
        this.loading = false;
        document.title = "Facilitator notes unavailable";
      })
    }

}

